import { FC, useState } from "react";
import { useSelector } from 'react-redux';

import styles from "../headerBtn.module.scss";

interface IOptions {
  setState: (state: string) => void;
};

const AddedDesktopOnCharts: FC<IOptions> = ({ setState }) => {
  const { desktopList } = useSelector((state: any) => state.charts?.chartsList);

  const [error, setError] = useState<string>('');

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    
    if (value === '') {
        setError('Вы ввели пустое значение.');
        setState('');
        return;
    }

    const sameNameItem = desktopList.find((el: any) => el.name === value);

    if (sameNameItem) {
        setError('Уже есть рабочий стол с таким названием.');
    } else {
        setError('');
        setState(value);
    }
  };

  return (
    <div className={styles.block__info}>
      <div className={styles.limit__block}>
        <span>Наименование:</span>
        <div className={styles.error__input_block}>
          <input
            type="text"
            defaultValue={''}
            className={error ? styles.error__input : styles.limit__input}
            onChange={handleChangeInput}
          />
          {error && <span className={styles.error}>{error}</span>}
        </div>
      </div>
    </div>
  );
};

export default AddedDesktopOnCharts;
